import { validators as sharedValidators } from '@gusiberi/shared'

export default sharedValidators
